
import Image from "next/image"

export default function Skill({ name, svgPath = null, bgColour, label, padding = "", modalHandler = null }) {
  return (
    <div 
      id={"skill-" + name} 
      className="cursor-pointer skill relative w-full h-26 lg:w-26 lg:h-26 py-4 mx-4 my-2 border transition"
      style={{ "backgroundColor": bgColour }}
      onClick={ () => modalHandler({ "showModal": true, "mode": name }) } >
      <div className="relative w-full h-full">
        <Image
          fill={true}
          className={"transition " + padding}
          src={svgPath}
          alt={label}
          priority={true}>
        </Image>
      </div>
    </div>
  );

}